export class LayoutViewBlock {
    public Id: string;
    public Name: string;
    public Enabled: boolean = true;
}
